import { combineReducers } from 'redux';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import notifications from 'ReduxMessenger/reducers/Notifications';
import appUser from './appUser';
import auth from './auth';
import isRestrictedImpersonatee from './isRestrictedImpersonatee';
import entities from './entities';
import errors from './errors';
import alerts from './alerts';
import interactions from './interactions';
import requestStatuses from './requestStatuses';
import securityPhoneNumber from './security/securityPhoneNumber';
import securityPhoneNumberSetup from './security/securityPhoneNumberSetup';
import stagedChanges from './stagedChanges';
import twoFactorAuth from './twoFactorAuth';
import requestStatusesOverride from './requestStatusesOverride';
import { sendAsEmails } from '../send-as-emails/reducers';
import { password } from '../password/reducers';
import navConfig from './navConfig';
export default combineReducers({
  appUser,
  auth,
  isRestrictedImpersonatee,
  interactions,
  entities,
  errors,
  alerts,
  requests: requestStatusesOverride(requestStatuses),
  twoFactorAuth,
  securityPhoneNumber,
  securityPhoneNumberSetup,
  stagedChanges,
  notifications,
  sendAsEmails,
  password,
  navConfig
});